import { TagButton } from 'primitives/buttons/tag-button'
import { Scroller } from 'primitives/scroller'
import { tw } from 'utils/classnames'
import type { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList'

import { useTagsList } from './hooks'

function prettyLabel(value: string) {
  return (
    value
      // Insert spaces before uppercase letters
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')
      // Capitalize each word
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
  )
}

function sortTags(a: RefinementListItem, b: RefinementListItem) {
  if (a.isRefined !== b.isRefined) {
    return a.isRefined ? -1 : 1
  }
  return a.label.localeCompare(b.label)
}

export function TagsSection({ tagClassName }: { tagClassName?: string }) {
  const { data, onValueChange } = useTagsList()

  if (!data?.length) {
    return <div className="h-[49px]" />
  }

  return (
    <Scroller.Root>
      <Scroller.ScrollArea gutter={0} gap={4}>
        {data?.sort(sortTags).map(tag => (
          <Scroller.ScrollItem key={tag.value} className="aspect-auto w-auto">
            <TagButton
              variant={tag.isRefined ? 'selected' : 'default'}
              onClick={() => onValueChange(tag.value)}
              selectedClassName="bg-violet-700 border-violet-700"
              className={tw(
                'active:text-service-white-white font-inter text-xs hover:border-violet-700 hover:bg-gray-700 active:border-violet-700 active:bg-violet-700',
                !tag.isRefined &&
                  'border-gray-800 text-gray-200 hover:border-gray-700 hover:bg-gray-800 hover:text-gray-200',
                tagClassName,
              )}
            >
              {prettyLabel(tag.label)}
            </TagButton>
          </Scroller.ScrollItem>
        ))}
      </Scroller.ScrollArea>
    </Scroller.Root>
  )
}
